import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=6fff6973&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"
import style0 from "./contacts.vue?vue&type=style&index=0&id=6fff6973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff6973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fff6973')) {
      api.createRecord('6fff6973', component.options)
    } else {
      api.reload('6fff6973', component.options)
    }
    module.hot.accept("./contacts.vue?vue&type=template&id=6fff6973&scoped=true&", function () {
      api.rerender('6fff6973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/account/contacts.vue"
export default component.exports